import { render, staticRenderFns } from "./widgetROI.vue?vue&type=template&id=6b9302da&scoped=true"
import script from "./widgetROI.vue?vue&type=script&lang=js"
export * from "./widgetROI.vue?vue&type=script&lang=js"
import style0 from "./widgetROI.vue?vue&type=style&index=0&id=6b9302da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9302da",
  null
  
)

export default component.exports